const currentYear = new Date().getFullYear();
const tenYearsAgo = currentYear - 10;
const checkoutFormModel = {
  formId: 'checkoutForm',
  formField: {
    resource: {
      name: 'resource',
      label: 'Recurso',
      requiredErrorMsg: 'Seleccione un recurso'
    },
    vehicleType: {
      name: 'vehicleType',
      label: 'Tipo de Rodado',
      requiredErrorMsg: ''
    },
    domain: {
      name: 'domain',
      label: 'Patente',
      requiredErrorMsg: 'Debe ingresar el número de patente',
      invalidErrorMsg: 'El valor ingresado es inválido',
      notFoundErrorMsg: 'El número de patente ingresado no corresponde a un rodado activo'
    },
    propertyNumber: {
      name: 'propertyNumber',
      label: 'N° de Partida',
      requiredErrorMsg: 'Debe ingresar el número de partida',
      invalidErrorMsg: 'El número de partida es inválido',
      notFoundErrorMsg: 'El número de partida ingresado no corresponde a un inmueble activo'
    },
    firstname: {
      name: 'firstname',
      label: 'Nombre del Titular',
      requiredErrorMsg: 'Ingrese el nombre del titular',
      charsErrorMsg: 'Máximo 100 caracteres.',
      invalidErrorMsg: 'Solo se aceptan caracteres alfabéticos, Ñ y acentos.'
    },
    lastname: {
      name: 'lastname',
      label: 'Apellido del Titular',
      requiredErrorMsg: 'Ingrese el apellido del titular',
      charsErrorMsg: 'Máximo 100 caracteres.',
      invalidErrorMsg: 'Solo se aceptan caracteres alfabéticos, Ñ y acentos.'
    },
    document: {
      name: 'document',
      label: 'DNI',
      requiredErrorMsg: 'Ingrese un número de documento',
      invalidErrorMsg: 'El documento ingresado es inválido'
    },
    areaPhone: {
      name: 'areaPhone',
      label: 'Cod. Área',
      requiredErrorMsg: 'Ingrese el código de área',
      invalidErrorMsg: 'El Cod. Área no debe contener letras o caracteres especiales'
    },
    phoneNumber: {
      name: 'phoneNumber',
      label: 'Teléfono',
      requiredErrorMsg: 'Ingrese un número de teléfono',
      invalidErrorMsg: 'El Teléfono no debe contener letras o caracteres especiales'
    },
    areaCellPhone: {
      name: 'areaCellPhone',
      label: 'Cod. Área',
      requiredErrorMsg: 'Ingrese el código de área',
      invalidErrorMsg: 'El Cod. Área no debe contener letras o caracteres especiales'
    },
    cellPhoneNumber: {
      name: 'cellPhoneNumber',
      label: 'Celular',
      requiredErrorMsg: 'Ingrese un número de celular',
      invalidErrorMsg: 'El número de celular no debe contener letras o caracteres especiales'
    },
    email: {
      name: 'email',
      label: 'Email',
      requiredErrorMsg: 'Ingrese una dirección de email',
      invalidErrorMsg: 'El formato del email ingresado no es válido'
    },
    emailConfirmation: {
      name: 'emailConfirmation',
      label: 'Volver a escribir el email',
      requiredErrorMsg: 'ingrese su email nuevamente',
      invalidErrorMsg: 'No coinciden los emails ingresados'
    },
    debitType: {
      name: 'debitType',
      label: 'Tipo Tarjeta',
      requiredErrorMsg: 'Seleccione alguna de las opciones'
    },
    cardBrand: {
      name: 'cardBrand',
      label: 'Tarjeta',
      requiredErrorMsg: 'Seleccione alguna de las opciones'
    },
    cardNumber: {
      name: 'cardNumber',
      label: 'N° de la tarjeta',
      requiredErrorMsg: 'Ingrese el número de la tarjeta',
      invalidErrorMsg: 'El número de tarjeta ingresado es inválido'
    },
    cardExpireFrom: {
      name: 'cardExpireFrom',
      label: 'Válida desde',
      requiredErrorMsg: 'Seleccione una fecha',
      invalidErrorMsg: 'La fecha ingresada es inválida',
      minErrorMsg: 'El año no puede ser menor a ' + tenYearsAgo
    },
    cardExpireTo: {
      name: 'cardExpireTo',
      label: 'Válida hasta',
      requiredErrorMsg: 'Seleccione una fecha',
      invalidErrorMsg: 'La fecha ingresada es inválida'
    },
    cbu: {
      name: 'cbu',
      label: 'CBU',
      requiredErrorMsg: 'Ingrese el número de cbu',
      invalidErrorMsg: 'El número de cbu ingresado no corresponde a uno del banco provincia'
    },
    cbuConfirmation: {
      name: 'cbuConfirmation',
      label: 'Confirmar CBU',
      requiredErrorMsg: 'Ingrese nuevamente el cbu',
      invalidErrorMsg: 'No coinciden los cbu ingresados'
    },
  }
};

export default checkoutFormModel;